// fc-gallery.js — horizontal image carousel (the "just images" gallery section).
// Vanilla custom element mirroring fc-brands: the track is a native CSS scroll-snap
// row; arrow buttons page it one slide at a time and disable at the ends. Mobile relies
// on native swipe. Reduced-motion users get instant (non-smooth) jumps. If the slides
// don't overflow, the whole control rail is hidden via an attr.
class FcGalleryCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-fc-gallery-track]');
    this.prevBtn = this.querySelector('[data-fc-gallery-prev]');
    this.nextBtn = this.querySelector('[data-fc-gallery-next]');
    if (!this.track) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.onScroll = this.onScroll.bind(this);

    this.prevBtn?.addEventListener('click', () => this.page(-1));
    this.nextBtn?.addEventListener('click', () => this.page(1));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    this.updateArrows();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  page(direction) {
    const slide = this.track.querySelector('[data-fc-gallery-slide]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: direction * step, behavior: this.reduceMotion ? 'auto' : 'smooth' });
  }

  onScroll() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => this.updateArrows());
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const overflowing = max > 1;
    this.toggleAttribute('data-no-overflow', !overflowing);
    if (!this.prevBtn || !this.nextBtn) return;
    this.prevBtn.disabled = !overflowing || this.track.scrollLeft <= 1;
    this.nextBtn.disabled = !overflowing || this.track.scrollLeft >= max - 1;
  }
}

if (!customElements.get('fc-gallery-carousel')) {
  customElements.define('fc-gallery-carousel', FcGalleryCarousel);
}
